import axios from 'axios';

const configuredBaseUrl = import.meta.env.VITE_API_URL;
const fallbackBaseUrl =
  typeof window !== 'undefined' ? window.location.origin : '';

export const apiBaseUrl = configuredBaseUrl || fallbackBaseUrl;

export function buildApiUrl(path: string) {
  const normalizedBaseUrl = apiBaseUrl.endsWith('/')
    ? apiBaseUrl
    : `${apiBaseUrl}/`;
  const normalizedPath = path.replace(/^\/+/, '');
  const resolvedBaseUrl =
    normalizedBaseUrl.startsWith('http://') ||
    normalizedBaseUrl.startsWith('https://')
      ? normalizedBaseUrl
      : typeof window !== 'undefined'
        ? new URL(
            normalizedBaseUrl.replace(/^\/+/, ''),
            `${window.location.origin}/`,
          ).toString()
        : normalizedBaseUrl;

  return new URL(normalizedPath, resolvedBaseUrl).toString();
}

export function getApiErrorMessage(
  error: unknown,
  fallback = 'Something went wrong',
) {
  if (axios.isAxiosError(error)) {
    const message = error.response?.data?.message;

    if (Array.isArray(message) && message.length > 0) {
      return String(message[0]);
    }

    if (typeof message === 'string' && message.trim().length > 0) {
      return message;
    }
  }

  return fallback;
}

export const api = axios.create({
  baseURL: apiBaseUrl,
  timeout: 10_000,
  withCredentials: false,
});
